// extracted by mini-css-extract-plugin
module.exports = {"options":"BtnOptions_options__3ttLz","options__container":"BtnOptions_options__container__1SS8m","button__container":"BtnOptions_button__container__3wZ1B"};